<template>
  <div class="signup">
    <NavHeaderBar title="会员注册" leftArrow rightArrow :onClickRight="onClickRight" />

    <van-form ref="form" @submit="onSubmit">
      <template v-for="item in model.formList">
        <van-field v-if="item.fieldName === 'name'" :key="item.fieldName" v-model="form[item.fieldName]"
          :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

        <div v-if="item.fieldName === 'mobile'" :key="item.fieldName">
          <van-field v-model="form[item.fieldName]" type="tel" :name="item.fieldName" placeholder="请输入手机号"
            :label="item.fieldTitle" :rules="[
              {
                pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
                message: '请填写正确的手机号'
              }
            ]" />
          <van-field v-model="form.smsCode" type="text" name="smsCode" placeholder="验证码" label="验证码"
            :rules="[{ required: true, message: '请填写验证码' }]">
            <template #button>
              <span style="font-size: 13px;color: #999999" @click="onClickCaptch(item.fieldName)">
                | 获取验证码
                {{
                captchaDisabledOverTime && captchaDisabledOverTime + "s"
                }}</span>
            </template>
          </van-field>
        </div>

        <van-field v-if="item.fieldName === 'gender'" :key="item.fieldName" :name="item.fieldName"
          :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]">
          <template #input>
            <van-radio-group v-model="form[item.fieldName]" direction="horizontal">
              <van-radio v-for="sex in item.dictList" :key="sex.dictValue" :name="sex.dictValue">{{ sex.dictName }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div v-if="item.fieldName === 'techLevel'" :key="item.fieldName">
          <van-field :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" readonly clickable
            v-model="form[item.fieldName]" @click="showPicker = true" />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="jisdjs" @confirm="onJisdjConfirm" @cancel="showPicker = false" />
          </van-popup>
        </div>

        <van-field v-if="item.fieldName === 'company'" :key="item.fieldName" v-model="form[item.fieldName]"
          :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

        <van-field v-if="item.fieldName === 'professional'" :key="item.fieldName" v-model="form[item.fieldName]"
          :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
          :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" />

        <div v-if="item.fieldName === 'city'" :key="item.fieldName">
          <van-field :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" readonly clickable
            v-model="form[item.fieldName]" @click="showArea = true" />
          <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showArea = false" />
          </van-popup>
        </div>

        <div v-if="item.fieldName === 'companyType'" :key="item.fieldName">
          <van-field :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`"
            :rules="[{ required: true, message: `请输入${item.fieldTitle}` }]" readonly clickable
            v-model="form[item.fieldName]" @click="showType = true" />
          <van-popup v-model="showType" position="bottom">
            <van-picker show-toolbar :columns="types" @confirm="onTypesConfirm" @cancel="showType = false" />
          </van-popup>
        </div>

        <van-field v-if="item.fieldName === 'email'" :key="item.fieldName" v-model="form[item.fieldName]"
          :name="item.fieldName" :label="item.fieldTitle" :placeholder="`请输入${item.fieldTitle}`" :rules="[
            { required: true, message: '请输入邮箱号!' },
            {
              pattern: /^\w+@[a-z0-9]+\.[a-z]+$/i,
              message: '邮箱号格式错误！'
            }
          ]" />
      </template>

      <div style="margin: 16px;" v-if="model.formList && model.formList.length > 0">
        <van-button block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import captcha from "@/mixins/captcha";
import apis from "@/config/yqyapis";
import { areaList } from "@vant/area-data";
import { Dialog } from "vant";
import { getCorpCode } from "@/config/yqy";

export default {
  mixins: [captcha],
  name: "Signup",
  data: () => ({
    corpCode: "",

    model: {},
    signprompt: "",
    form: {
      uname: ""
    },
    jisdjs: [
      "主任医师",
      "主任药师",
      "主任护师",
      "主任技师",
      "副主任医师",
      "副主任药师",
      "副主任护师",
      "副主任技师",
      "主治（主管）医师",
      "主管药师",
      "主管护师",
      "主管技师",
      "医师、医士",
      "药师、药士",
      "护师、护士",
      "技师、技士",
      "其他"
    ],
    areaList,
    types: ["医院", "药房", "科研机构", "其他"],
    showPicker: false,
    showArea: false,
    showType: false,
    needCaptcha: true
  }),
  created() {
    this.corpCode = getCorpCode();
    this.registerForm();
    //   this.getUserInfo();
    //  this.getNeedcaptcha();
  },
  methods: {
    async registerForm() {
      const resp = await apis.member.registerForm();
      this.model = resp.data;
    },
    async onSubmit(values) {
      const resp = await apis.member.saveRegister(values);
      if (resp.success === true) {
        Dialog.alert({
          title: "温馨提示",
          message: "注册成功！"
        }).then(() => {
          this.$router.push({
            path: "/dw/",
            query: { corpCode: this.corpCode }
          });
        });
      }
      else {
        Dialog.alert({
          title: "错误",
          message: resp.msg,
        });
      }
    },
    onClickCaptch(name) {
      this.$refs.form
        .validate([name])
        .then(() => {
          this.onClickGetCaptcha(this.form[name], 3);
        })
        .catch(err => {
          console.log(err);
        });
    },
    onJisdjConfirm(value) {
      this.form.techLevel = value;
      this.showPicker = false;
    },
    onAreaConfirm(values) {
      this.form.city = values
        .filter(item => !!item)
        .map(item => item.name)
        .join("/");
      this.showArea = false;
    },
    onTypesConfirm(value) {
      this.form.companyType = value;
      this.showPicker = false;
    },
    onClickRight() {
      this.$router.push(
        {
          path: "/dw/",
          query: { corpCode: this.corpCode }
        });

    },
  }
};
</script>

<style lang="scss">
.signup {
  padding-top: 46px;

  .msg {
    font-size: 13px;
    padding: 15px;
    line-height: 1.4;

    .msg-icon {
      margin-right: 4px;
      vertical-align: text-top;
    }
  }
}
</style>
